module.exports = __webpack_public_path__ + "img/xiaobiaoti.461a5a2f.png";